import { combineReducers } from 'redux';
import filters from './filters';
import oas from './oas';
import mapReducer from './mapReducer';
import activities from './activities';

const reducer = combineReducers({
  oasState: oas,
  filterState: filters,
  mapState: mapReducer,
  activitiesState: activities,

});

export default reducer;
